module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_2.eafcff3d.png";